export interface LiveTask {
  id: string;
  city: string;
  countryCode: string;
  title: string;
  payout: number;
  category: string;
}

export const liveTasks: LiveTask[] = [
  { id: 't1', city: 'Bogotá', countryCode: 'CO', title: 'Test checkout with a local debit card', payout: 8, category: 'Payments' },
  { id: 't2', city: 'Lagos', countryCode: 'NG', title: 'Photograph shelf placement at 3 pharmacies', payout: 14, category: 'Retail audit' },
  { id: 't3', city: 'Jakarta', countryCode: 'ID', title: 'Call support line and log wait time', payout: 6, category: 'Support' },
  { id: 't4', city: 'Lisbon', countryCode: 'PT', title: 'Verify a café is open and matches listing', payout: 5, category: 'Verification' },
  { id: 't5', city: 'Manila', countryCode: 'PH', title: 'Sign up and top up a mobile wallet', payout: 11, category: 'Payments' },
  { id: 't6', city: 'Nairobi', countryCode: 'KE', title: 'Order delivery and time the courier', payout: 12, category: 'Logistics' },
  { id: 't7', city: 'São Paulo', countryCode: 'BR', title: 'Pay with Pix and screenshot the receipt', payout: 9, category: 'Payments' },
  { id: 't8', city: 'Seoul', countryCode: 'KR', title: 'Check game latency on a local ISP', payout: 10, category: 'Gaming' },
  { id: 't9', city: 'Mexico City', countryCode: 'MX', title: 'Pick up a parcel from an OXXO store', payout: 7, category: 'Logistics' },
  { id: 't10', city: 'Istanbul', countryCode: 'TR', title: 'Book a hotel room and confirm amenities', payout: 16, category: 'Concierge' },
];
